import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../services/general.service';


export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const generalService = inject(GeneralService); // 👈 inject your service here

  // Simulating an asynchronous check (e.g., an API call to validate the token)
  return new Promise<boolean>(async (resolve) => {
    const accessToken = localStorage.getItem('ALTOMATE_ACCESS_TOKEN_KEY');
    if (accessToken && generalService.isAltomateLink()) {
      // If the token exists, allow navigation
      resolve(true);
    } else {
      // If no token, redirect to login page
      const redirectUrl = encodeURIComponent(state.url);
      router.navigate(['/login'], { queryParams: { redirectUrl } });
      resolve(false);

    }
  });

};
